export const isStringArraySubsetOfStringArray = (array1: string[], array2: string[]) =>
    array1.every((val) => array2.includes(val));
